var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 114.57",
    style: {
      enableBackground: "new 0 0 122.88 114.57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.34,30.91h46.22l-7.99-13.84c0.77-3.85,3.01-5.15,6.73-3.89l10.23,17.73h4.04L80.78,0.35 c3.51-0.9,6.12-0.23,6.74,3.89L71.64,30.91h47.91c1.84,0,3.34,1.5,3.34,3.34v76.98c0,1.83-1.5,3.34-3.34,3.34H3.34 c-1.84,0-3.34-1.5-3.34-3.34V34.25C0,32.42,1.5,30.91,3.34,30.91L3.34,30.91z M105.39,102.06c2.4,0,4.35,1.95,4.35,4.35 c0,2.4-1.95,4.35-4.35,4.35c-2.4,0-4.35-1.95-4.35-4.35C101.05,104.01,102.99,102.06,105.39,102.06L105.39,102.06z M9.03,103.01 h32.67c0.5,0,0.91,0.41,0.91,0.92v4.95c0,0.5-0.41,0.92-0.91,0.92H9.03c-0.5,0-0.91-0.41-0.91-0.92v-4.95 C8.12,103.43,8.53,103.01,9.03,103.01L9.03,103.01L9.03,103.01z M10.8,38.56h101.27c1.48,0,2.69,1.2,2.69,2.66v53.85 c0,1.46-1.21,2.66-2.69,2.66H10.8c-1.48,0-2.69-1.2-2.69-2.66V41.22C8.12,39.76,9.32,38.56,10.8,38.56L10.8,38.56z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/television.2d896fca.svg";
export { ForwardRef as ReactComponent };